export default __webpack_public_path__ + "static/media/order-step-completed.65eaee01.svg";